import React, { useEffect } from "react";

import {
    SignupUFOExperience,
    UfoCustomTimingKey
} from "@/components/signup/utils";

type UfoCustomTimingWrapperProps = {
    ufoEvent: SignupUFOExperience;
    ufoCustomTimingKey: UfoCustomTimingKey;
    children: React.ReactNode;
};

export const UfoCustomTimingWrapper = ({
    ufoEvent,
    ufoCustomTimingKey,
    children
}: UfoCustomTimingWrapperProps) => {
    useEffect(() => {
        ufoEvent.startSubstep(ufoCustomTimingKey);

        return () => {
            ufoEvent.endSubstep(ufoCustomTimingKey);
        };
    }, []);

    return <>{children}</>;
};
